import SliderSettings from './SliderSettings/SliderSettings'
import SliderControls from './SliderControls/SliderControls'

export { SliderSettings, SliderControls }
